const localSettings = {
  fileListScale: 1,
}
// eslint-disable-next-line
try {Object.assign(localSettings, JSON.parse(localStorage.localSettings))} catch (e) {}

export default localSettings
